import React from "react";
import { List } from "@refinedev/mui";
import { Tab, Tabs } from "@mui/material";
import { useSearchParams } from "react-router";
import { useTranslate } from "@refinedev/core";

import { PartnersTab } from "./tabs/PartnersTab";
import { ReferralsTab } from "./tabs/ReferralsTab";
import { TiersTab } from "./tabs/TiersTab";
import { MonthlyTab } from "./tabs/MonthlyTab";
import { SnapshotsTab } from "./tabs/SnapshotsTab";
import { AuditLogTab } from "./tabs/AuditLogTab";

const TABS = ["partners", "referrals", "tiers", "monthly", "snapshots", "audit"] as const;
type PartnersPageTab = (typeof TABS)[number];

export const PartnersList = React.memo(() => {
  const translate = useTranslate();
  const [searchParams, setSearchParams] = useSearchParams();

  const tabParam = searchParams.get("tab") as PartnersPageTab | null;
  const tab: PartnersPageTab =
    tabParam && (TABS as readonly string[]).includes(tabParam) ? tabParam : "partners";

  return (
    <List title={translate("partners.title")} headerButtons={<></>}>
      <Tabs
        value={tab}
        onChange={(_, value: PartnersPageTab) => setSearchParams({ tab: value })}
        variant="scrollable"
        sx={{ mb: 2 }}
      >
        {TABS.map((value) => (
          <Tab key={value} value={value} label={translate(`partners.tabs.${value}`)} />
        ))}
      </Tabs>

      {tab === "partners" && <PartnersTab />}
      {tab === "referrals" && <ReferralsTab />}
      {tab === "tiers" && <TiersTab />}
      {tab === "monthly" && <MonthlyTab />}
      {tab === "snapshots" && <SnapshotsTab />}
      {tab === "audit" && <AuditLogTab />}
    </List>
  );
});
